import React from 'react';
import { useAuth } from '../context/auth-context';
import { Navigate } from 'react-router-dom';

export function ProtectedRoutes({children}) {
  const {user} =  useAuth();
  if (user === null) {
      return <Navigate to="/login"></Navigate>;
  } 
  if(user === undefined) {
    return <div></div>
  }

  return <>{children}</>
}

export default ProtectedRoutes